import type {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';

export class RecordPaymentUseCase {
  constructor (private salesDashboardRepository: SalesDashboardRepository) {}

  async execute (paymentData: {invoice_id: number; amount: number; payment_method: string; notes?: string}): Promise<BaseResponse<unknown>> {
    return this.salesDashboardRepository.recordPayment(paymentData);
  }
}
